import { fetchTemplateInstancesPage } from 'common/services/template'
import { fetchBrandAndProductsList } from 'common/services/brand'
import { BRAND_LIST_PAGE_SIZE, Sort, SubVertical } from 'common/constants'
import { TemplateManagerKey } from 'common/constants/templateManager'
import { BrandCard } from 'common/types/entities/brand'

export interface BrandCardsState {
  brandCards: BrandCard[]
  hasMore?: boolean
  pageCount?: number
  page?: number
  cacheParam?: string
}

const initialState: BrandCardsState = {
  brandCards: [],
  hasMore: false,
  pageCount: 0,
  page: 0,
  cacheParam: null,
}

const FETCH_BRAND_CARD = 'brand/brandCard/FETCH_BRAND_CARD'

export const fetchBrandCards = (curState, page) => async (dispatch, getState) => {
  const brandCardsState = getState().brandCards[curState]
  const templatesPage = await fetchTemplateInstancesPage(TemplateManagerKey.ART_ARTIST_LIST, {
    page,
    preview: true,
    pageSize: BRAND_LIST_PAGE_SIZE,
    sort: Sort.RECENT,
  })
  const brandIds = templatesPage && templatesPage.instances && templatesPage.instances.map(instance => instance._id)
  const results: BrandCard[] = await fetchBrandAndProductsList(SubVertical.ART, brandIds, 3)
  const brandCards = page === 1 ? results : [...brandCardsState.brandCards, ...(results || [])]
  dispatch({
    curState,
    page,
    brandCards: brandCards || [],
    hasMore: templatesPage.hasMore,
    type: FETCH_BRAND_CARD,
  })
}

const brandCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_CARD:
      return {
        ...action,
      }
    default:
      return state
  }
}

export default brandCardReducer
